import { getShareLink } from '@/shared/helpers/telegram/share/share-game';
import { useShare } from '@/shared/hooks/use-share/use-share';
import { useAppState } from '@/shared/stores/app-store/app-store';

import { Method } from '../types';
import { validateMessageData } from './validate-message-data';
import { warnIncorrectValues } from './warn-incorrect-values';

export const useCustomShareHandler = () => {
  const { game } = useAppState();
  const share = useShare('game');

  const customSharing = (value: any, text: string) => {
    if (!game) return;
    let shareLink;
    let customText;

    if (value?.parameters) {
      const { text, parameters } = value;

      if (!validateMessageData({ value: parameters, allowedTypes: ['object'] })) {
        warnIncorrectValues(Method.CUSTOM_SHARE, 'parameters', ['object']);
      }
      if (!validateMessageData({ value: text, allowedTypes: ['undefined', 'string'] })) {
        warnIncorrectValues(Method.CUSTOM_SHARE, 'parameters', ['undefined', 'string']);
      }
      shareLink = getShareLink(game.key, parameters);
      customText = text;
    } else {
      customText = text;
      shareLink = getShareLink(game.key, value);
    }

    return share(customText, shareLink);
  };

  return customSharing;
};
